module.exports = __webpack_public_path__ + "img/dolar-pound.4d00d683.png";